import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

const Tabs = styled('nav')`
  display: flex;
  background: ${p => themeGet('colors.white')(p)};
`;

export default Tabs;
